module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2086/plan2-3-935c646ffeacceaac93872db02f39d54.webp";